// removed by extract-text-webpack-plugin
module.exports = {"light-grey":"#d4d4d4","grey":"#707070","table":"_3S9qSClA7QEEK7iBtmm7NT","tableRow":"_1EzoGdyMPo0b1BNAmgYlUF","tableCell":"_1A--ftOiZVO0qmzPVuH5hK","tableHead":"_2lV04Mqgpvzl97eW3H2sVI","grow":"_1tAdcTtN0HrN_TtZ7MJgWh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataTable/DataTable.css
// module id = 1480
// module chunks = 0